import React, { useEffect, useState } from "react";
import { CardContent, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { amber } from "@mui/material/colors";
import MainCard from "../../common/card/MainCard";
import IncomeStatusCard from "../income/IncomeStatusCard.component";
import { useTranslation } from "react-i18next";

const StatusStationsCard = ({
  active = 0,
  allarm = 0,
  warning = 0,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const matchMd = useMediaQuery(theme.breakpoints.only('xs'));

  const [tot, setTot] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (active !== null && allarm !== null && warning !== null) {
      setTot(active + allarm + warning)
      setLoading(false)
    }
  }, [active, allarm, warning])

  return loading ? <IncomeStatusCard /> : (
    <MainCard
      title={t('status-of-monitoring-points')}
      contentSX={{ "&.MuiCardContent-root": { padding: matchMd ? 1.5 : '24px' } }}
      sx={{
        width: "100%",
        border: "1px solid #E6DEB8",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent sx={{ "&.MuiCardContent-root": { padding: 0 } }}>
        <Grid container display="flex" alignItems="center" spacing={matchMd ? 0 : 4}>
          <Grid
            item
            container
            xs={4}
            sm={12}
            md={12}
            lg={12}
            display="flex"
            alignItems={"center"}
            justifyContent={{xs: "center", sm: "normal"}}
          >
            <Grid
              item
              sx={{
                height: matchMd ? 22 : 38,
                maxHeight: matchMd ? 22 : 38,
                width: matchMd ? 22 : 38,
                maxWidth: matchMd ? 22 : 38,
                backgroundColor: "#D90001",
                borderRadius: "50%",
                boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)",

              }}
            />
            <Grid item ml={1} >
              <Typography
                variant="h2"
                sx={{ fontSize: matchMd ? 16 : 26 }}
                noWrap
              >{`${allarm} / ${tot}`}</Typography>
              <Typography sx={{ fontSize: matchMd ? 11 : 12 }}>{t('critic')}</Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            xs={4}
            sm={12}
            md={12}
            lg={12}
            display="flex"
            alignItems={"center"}
            justifyContent={{xs: "center", sm: "normal"}}
          >
            <Grid
              item
              sx={{
                height: matchMd ? 22 : 38,
                maxHeight: matchMd ? 22 : 38,
                width: matchMd ? 22 : 38,
                maxWidth: matchMd ? 22 : 38,
                backgroundColor: amber[500],
                borderRadius: "50%",
                boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)",

              }}
            />
            <Grid item ml={1}>
              <Typography
                variant="h2"
                sx={{ fontSize: matchMd ? 16 : 26 }}
                noWrap
              >{`${warning} / ${tot}`}</Typography>
              <Typography sx={{ fontSize: matchMd ? 11 : 12 }}>{t('warning')}</Typography>

            </Grid>
          </Grid>

          <Grid
            item
            container
            xs={4}
            sm={12}
            md={12}
            lg={12}
            display="flex"
            alignItems={"center"}
            justifyContent={{xs: "center", sm: "normal"}}
          >
            <Grid
              item
              sx={{
                height: matchMd ? 22 : 38,
                maxHeight: matchMd ? 22 : 38,
                width: matchMd ? 22 : 38,
                maxWidth: matchMd ? 22 : 38,
                backgroundColor: "#6E945F",
                borderRadius: "50%",
                boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)",

              }}
            />
            <Grid item ml={1}>
              <Typography
                variant="h2"
                sx={{ fontSize: matchMd ? 16 : 26 }}
                noWrap
              >{`${active} / ${tot}`}</Typography>
              <Typography>OK</Typography>
            </Grid>
          </Grid>


        </Grid>
      </CardContent>
    </MainCard >

  );
};

export default StatusStationsCard;
